@use "@/styles/variables" as *;

.content {
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.loadingOverlay {
	position: absolute;
	inset: 0;
	z-index: 20;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(255, 255, 255, 0.74);
	backdrop-filter: blur(1px);
	border-radius: 6px;
}

.summaryBar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
	padding: 8px 10px;
	border: 1px solid #e2e8f0;
	border-radius: 6px;
	background: #f8fafc;
	color: #334155;
}

.summaryItem {
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 0;
}

.summaryItem span {
	font-size: 0.75rem;
	font-weight: 700;
	color: #64748b;
}

.summaryItem strong {
	font-size: 0.86rem;
	color: #1e293b;
	white-space: nowrap;
}

.lines {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.lineRow {
	display: grid;
	grid-template-columns: minmax(190px, 1.15fr) minmax(150px, 0.75fr) minmax(250px, 1.35fr) minmax(170px, 0.85fr);
	gap: 10px;
	align-items: center;
	padding: 10px 12px;
	border: 1px solid $gray-200;
	border-radius: 6px;
	background: #ffffff;
	transition:
		border-color 0.15s ease,
		box-shadow 0.15s ease,
		background-color 0.15s ease;
}

.lineFinished {
	border-color: rgba($primary-color, 0.55);
	background: $primary-bg;
	box-shadow: inset 0 0 0 1px rgba($primary-color, 0.08);
}

.productBlock {
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
}

.productBlock strong {
	font-size: 0.94rem;
	color: #0f172a;
}

.productBlock span,
.quantityGrid span,
.message,
.availableMessage,
.unavailableMessage {
	font-size: 0.78rem;
	color: #64748b;
}

.quantityGrid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 8px;
}

.quantityGrid div {
	display: flex;
	flex-direction: column;
	gap: 3px;
}

.quantityGrid strong {
	font-size: 0.86rem;
	color: #1e293b;
}

.codesBlock {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	min-width: 0;
}

.codePill {
	display: inline-flex;
	align-items: center;
	max-width: 100%;
	padding: 3px 7px;
	border-radius: 6px;
	background: #ecfdf5;
	color: #166534;
	font-size: 0.76rem;
	font-weight: 600;
	white-space: nowrap;
}

.actionBlock {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 6px;
}

.finishedCheck {
	display: inline-flex;
	align-items: center;
	gap: 5px;
	font-size: 0.79rem;
	font-weight: 700;
	color: $secondary-color;
}

.availableMessage {
	color: $secondary-color;
	text-align: right;
}

.finishedMessage {
	color: $secondary-color;
	text-align: right;
}

.unavailableMessage {
	color: $warning-color;
	text-align: right;
}

.emptyState {
	padding: 24px;
	border: 1px solid #e2e8f0;
	border-radius: 6px;
	text-align: center;
	color: #64748b;
}

@media (max-width: 1200px) {
	.lineRow {
		grid-template-columns: 1fr;
		align-items: stretch;
	}

	.actionBlock {
		align-items: flex-start;
	}

	.availableMessage,
	.unavailableMessage {
		text-align: left;
	}
}

@media (max-width: 640px) {
	.summaryBar,
	.quantityGrid {
		grid-template-columns: 1fr;
		flex-direction: column;
		align-items: flex-start;
	}
}
